import { useState } from 'react';

export function SaveContinueLaterButton({ onSaveAndExit, disabled = false, busy: externalBusy = false }) {
    const [busy, setBusy] = useState(false);
    const isBusy = busy || externalBusy;

    const handleClick = async () => {
        if (isBusy || disabled) return;
        setBusy(true);
        try {
            await onSaveAndExit();
        } finally {
            setBusy(false);
        }
    };

    return (
        <button
            type="button"
            className="save-continue-btn"
            onClick={handleClick}
            disabled={disabled || isBusy}
        >
            {isBusy ? 'Saving…' : 'Save & continue later'}
        </button>
    );
}
